import Home from 'components/Home/Home';

import './App.css';

const App = () => <Home />;

export default App;
